import { render } from "./showOrder.vue?vue&type=template&id=72a1e29c&scoped=true"
import script from "./showOrder.vue?vue&type=script&lang=js"
export * from "./showOrder.vue?vue&type=script&lang=js"

import "./showOrder.vue?vue&type=style&index=0&id=72a1e29c&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a1e29c"]])

export default __exports__